export default {
  initial: '/',
  authLogin: '/auth/login',
  authForgotPassword: '/auth/forgot-password',
  authResetPassword: '/auth/reset-password',
  authProfile: '/my-account',
  orders: "/sales/orders",
  shipments: "/sales/shipments",
  invoices: "/sales/invoices",
  transactions: "/sales/transactions",

  products: "/catalog/products",
  categories: "/catalog/categories",
  woods: "/catalog/woods",
  warehouses: "/catalog/warehouses",

  settingsGeneral: "/settings/general",
  settingsUsers: "/settings/users",
}
